import pendingApprovalSummaryComponentUrl from './pendingApprovalSummaryComponent.html';

class PendingApprovalSummaryCtrl {
  constructor(EventCollection, AvailabilityUtils, sdk) {
    'ngInject';

    Object.assign(this, { EventCollection, AvailabilityUtils, sdk });
  }

  $onChanges() {
    if (this.mode !== this.groupsProcessingMode) {
      return;
    }

    this.countedEventIds = {};
    if (this.mode === this.sdk('constants').PROCESSING_MODES.USER_AGGREGATED) {
      this.calculateUserAggregatedSummary();
    } else {
      this.calculateUserSeparatedSummary();
    }
  }

  calculateUserSeparatedSummary() {
    if (!this.groups) {
      this.summary = null;
      return;
    }

    this.resetSummary();
    Object.values(this.groups).forEach((group) => {
      Object.values(group.users).forEach((user) => {
        const { events } = user;
        Object.values(events).forEach((event) => {
          event.forEach(this.handleEvent.bind(this));
        });
      });
    });
  }

  calculateUserAggregatedSummary() {
    if (!this.groups) {
      this.summary = null;
      return;
    }

    this.resetSummary();
    Object.keys(this.groups).forEach((dateString) => {
      const { events, available } = this.groups[dateString];
      events.forEach(this.handleEvent.bind(this));

      if (available) {
        available.forEach(this.handleEvent.bind(this));
      }
    });
  }

  resetSummary() {
    this.summary = {
      available: 0,
      offers: 0,
      leaves: 0,
      unavailabilities: 0,
      get pending() {
        return this.available + this.offers + this.leaves + this.unavailabilities;
      },
    };
  }

  handleEvent(event) {
    if (!this.countedEventIds[event.id]) {
      if (event.offer) {
        this.summary.offers++;
      } else if (event.available) {
        this.summary.available++;
      } else if (this.EventCollection.isTimeOff(event.type)) {
        this.summary.leaves++;
      } else if (event.type === 'availability') {
        this.summary.unavailabilities++;
      }
    }

    this.countedEventIds[event.id] = true;
  }

  get isSummaryLoaded() {
    return this.summary && this.active;
  }

  get shouldShowUnavailabilities() {
    return this.AvailabilityUtils.isApprovalEnabled();
  }
}

export default {
  bindings: {
    mode: '<',
    groupsProcessingMode: '<',
    groups: '<',
    active: '<',
  },
  controllerAs: 'ctrl',
  controller: PendingApprovalSummaryCtrl,
  templateUrl: pendingApprovalSummaryComponentUrl,
};
